module.exports = __webpack_public_path__ + "static/favicon-0039d50fb5943bc0629ef4d3ff1ae4b9.ico";